import { defineRouteMiddleware, navigateTo } from '@/shared/utils/router.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

export default defineRouteMiddleware(function redirectIfAuthenticated(to) {
    const authStore = useAuthStore();

    if (to.name !== 'dashboard' && authStore.isAuthenticated) {
        return navigateTo({
            name: 'dashboard',
        });
    }
});
